
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_wgsr6_145",
  "marker--line": "awsui_marker--line_1isd1_wgsr6_185",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_wgsr6_189",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_wgsr6_196",
  "marker--dashed": "awsui_marker--dashed_1isd1_wgsr6_212"
};
  